<template>
    <div class="bg-grey-lightest">
        <section id="heading" class="pt-12 pb-24">
            <!-- Header Nav -->
            <header-nav ref="headerNav"></header-nav>
        </section>
        <section class="py-12">
            <div class="max-w-sm mx-auto px-6">
                <patient-loading v-if="! office"></patient-loading>
                <div class="rounded bg-white shadow relative -mt-24" v-else>
                    <router-link :to="{ path: '/search', query: { type: office.medicalPractice } }" class="text-whiter hover:text-white text-xl absolute pin-t pin-r p-2 m-2">
                        <span class="icon"><i class="mdi mdi-close"></i></span>
                    </router-link>
                    <div class="p-6 bg-orange text-white rounded-t">
                        <span class="inline-flex items-center justify-between bg-transparent uppercase font-semibold text-white text-left text-sm">
                            <div>{{ $t('Appointment_provided_by_X', { name: office.partnerName }) }}</div>
                        </span>
                        <div class="mt-4 text-sm">
                            {{ $t('This_appointment_is_provided_by_our_partner_X', { name: office.partnerName }) }}
                            {{ $t('Thus_you_will_be_redirected_to_their_website_in_order_to_book_it') }}
                        </div>
                    </div>
                    <div class="p-6">
                        <div class="mb-4 flex justify-between">
                            <div>
                                <div class="text-blue text-sm font-semibold mb-1">{{ $t('Who_will_treat_me_') }}</div>
                                <div class="text-grey-darkest">{{ office.doctorFirstName + ' ' + office.doctorLastName }}</div>
                                <div class="text-green font-semibold text-sm mt-1" v-if="office.isDoctorRegulated && (office.medicalPractice !== 'OSTEOPATH' && office.medicalPractice !== 'PSYCHOLOGIST')">{{ $t('Regulated_Doctor') }}</div>
                                <div class="text-red font-semibold text-sm mt-1" v-if="!office.isDoctorRegulated && (office.medicalPractice !== 'OSTEOPATH' && office.medicalPractice !== 'PSYCHOLOGIST')">{{ $t('Contracted_doctor_negative') }}</div>
                            </div>
                            <partner-avatar :external-url="office.doctorAvatar" class="ml-2 w-10 h-10"></partner-avatar>
                        </div>
                        <div class="">
                            <div class="text-blue text-sm font-semibold mb-1">{{ $t('Where_have_I_to_go_') }}</div>
                            <div class="text-grey-darkest">
                                {{ office.officeStreetName }}<br />
                                {{ office.officeZipCode }} {{ office.officeLocality }}
                            </div>
                        </div>
                    </div>
                    <gmap-map
                        :center="{lat: parseFloat(office.officeLatitude), lng: parseFloat(office.officeLongitude) }"
                        :zoom="13"
                        :options="{disableDefaultUI: true}"
                        style="height: 250px;"
                        class="w-full">
                            <gmap-marker
                                :position="{lat: parseFloat(office.officeLatitude), lng: parseFloat(office.officeLongitude) }"></gmap-marker>
                        </gmap-map>
                    <div class="px-6 py-4">
                        <a v-if="userId" :href="office.partnerUrl" @click.prevent="handleClick" target="_blank" class="inline-block text-center bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3">{{ $t('Book_this_appointment_with_X', { partner: office.partnerName }) }}</a>
                        <button v-else @click="showLogin" class="bg-blue-light hover:bg-blue rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3">{{ $t('Sign_in_to_book_this_appointment') }}</button>
                    </div>
                </div>
                <dfp-slot
                    v-if="office"
                    path="/21865209613/Patients/PartnerOfficeShow"
                    :size="[300,250]"
                    :id="`div-gpt-ad-partner-office`"
                    :medical-practice="office.medicalPractice"
                    class="mt-6" />
            </div>
        </section>
    </div>
</template>

<script>
import axios from 'axios'
import helpers from '@/mixins/helpers'

import HeaderNav from '@/components/Patient/HeaderNav'
import PartnerAvatar from '@/components/PartnerAvatar.vue'

export default {
    name: 'PartnerOfficeShow',

    mixins: [helpers],

    components: {HeaderNav, PartnerAvatar},

    data () {
        return {
            office: null,
        }
    },

    mounted () {
        this.fetchOffice()
    },

    methods: {
        showLogin () {
            this.$refs.headerNav.showLogin()
        },

        async handleClick () {
            await this.$ga.event({
                eventCategory: 'PartnerTimeSlot',
                eventAction: 'BookPartnerTimeSlot',
                eventLabel: this.office.partnerName
            })

            window.open(this.office.partnerUrl, '_blank')
        },

        fetchOffice () {
            let doctorId = this.$route.query.doctorId
            let latitude = this.$route.query.latitude
            let longitude = this.$route.query.longitude
            let medicalPractice = this.$route.query.medicalPractice

            axios.get(process.env.CLOUD_FUNCTIONS_BASE_URI + '/getPartnerOffices', {
                params: {
                    userId: this.userId,
                    medicalPractice: medicalPractice,
                    language: this.patientLanguage.shortCode,
                    latitude: latitude,
                    longitude: longitude,
                },
                headers: {
                    'Content-Type':  'application/json',
                }
            })
            .then(({ data }) => {
                let offices = data.filter((office) => {
                    return office.doctorId == doctorId
                })

                if (offices.length > 0) {
                    this.office = offices[0]
                } else {
                    alert($('This_office_does_not_exist'))
                    this.$router.push('/')
                }
            })
            .catch(error => {
                console.log('error', error)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Patient/PartnerOfficeShow.vue